import { render } from "./group-section.vue?vue&type=template&id=09012cfc&bindings={\"itemListKeys\":\"props\",\"group\":\"props\"}"
import script from "./group-section.vue?vue&type=script&lang=js"
export * from "./group-section.vue?vue&type=script&lang=js"

import "./group-section.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script